type WebviewMessageType = "webview_close" | "token_refresh_request";

interface WebviewMessage {
  type: WebviewMessageType;
  payload?: Record<string, unknown>;
}

export interface WebviewTokenResponse {
  token: string;
  refresh_token: string;
  refresh_exp: number;
}

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

export const isWebviewBridgeAvailable = (): boolean => {
  return (
    typeof window !== "undefined" &&
    typeof window.ReactNativeWebView?.postMessage === "function"
  );
};

export const postWebviewMessage = (
  type: WebviewMessageType,
  payload?: Record<string, unknown>,
): void => {
  const message: WebviewMessage = { type, ...(payload && { payload }) };
  window.ReactNativeWebView?.postMessage(JSON.stringify(message));
};

export const waitForWebviewMessage = <T>(
  expectedType: string,
  timeoutMs: number,
): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      window.removeEventListener("message", handler);
      reject(new Error(`Timeout waiting for message: ${expectedType}`));
    }, timeoutMs);

    const handler = (event: MessageEvent) => {
      try {
        const data =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;

        if (data?.type === expectedType) {
          clearTimeout(timer);
          window.removeEventListener("message", handler);
          resolve(data.payload as T);
        }
      } catch {
        // Ignore non-JSON messages
      }
    };

    window.addEventListener("message", handler);
  });
};
